<template>
  <div class="u-item clearfix">
    <div class="u-avatar">
      <router-link to="/" class="avatar-f">
        <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
      </router-link>
    </div>
    <div class="u-infoes">
      <div class="u-name-title clearfix">
        <router-link to="/" class="name">用户1</router-link>
        <span class="huifu">回复</span>
        <router-link to="/" class="name">人人动画</router-link>
        <span class="show-date">2天前</span>
      </div>
      <overflow-words class="words" words="普通优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付优势而附加贷款首付" />

      <div class="zan-cai-date clearfix">
        <div class="zan-cai">
          <div class="item active">
            <span class="zc-icon zan"></span>
            <span class="count">200</span>
          </div>
          <div class="item" @click="pinglunThirdEvent">
            <span class="zc-icon pinglun"></span>
          </div>
        </div>
      </div>
      <div class="console-ipt" v-if="showFours">
        <el-input
          class="textarea"
          type="textarea"
          :rows="1"
          placeholder="请输入内容"
          v-model="textConFours"
        >
        </el-input>
        <div class="checked-btn clearfix">
          <el-button class="fabu-btn" type="primary" size="mini">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import overflowWords from './overflow'

export default {
  components: {
    overflowWords
  },
  data () {
    return {
      showFours: false,
      textConFours: ''
    }
  },
  methods: {
    pinglunThirdEvent () {
      this.showFours = !this.showFours
    },
  }
}
</script>

<style scoped lang="less">
.huifu,
.show-date{
  margin: 0 5px;
  font-size: 12px;
}
.zan-cai-date{
  margin-bottom: 10px;
}
</style>
